import type { MessengerMessage } from '@/api/client';
import type { MessengerSocketThreadMeta } from '@/lib/messengerNotificationPreview';

/** Событие `messenger:messages_batch`: несколько сообщений одной атомарной вставкой (один сокет на получателя). */
export type MessengerMessagesBatchSocketEnvelope = {
  messages: MessengerMessage[];
  thread: MessengerSocketThreadMeta | null;
};

/** Событие `messenger:message`: обёртка с метаданными треда или «голое» сообщение (обратная совместимость). */
export type MessengerMessageSocketEnvelope = {
  message: MessengerMessage;
  thread: MessengerSocketThreadMeta | null;
};

export function unwrapMessengerMessageSocketPayload(raw: unknown): MessengerMessageSocketEnvelope {
  if (raw && typeof raw === 'object' && 'message' in raw) {
    const o = raw as Record<string, unknown>;
    const msg = o.message;
    if (msg && typeof msg === 'object') {
      const threadRaw = o.thread;
      const thread =
        threadRaw && typeof threadRaw === 'object'
          ? (threadRaw as MessengerSocketThreadMeta)
          : null;
      return { message: msg as MessengerMessage, thread };
    }
  }
  return { message: raw as MessengerMessage, thread: null };
}

export function unwrapMessengerMessagesBatchSocketPayload(
  raw: unknown
): MessengerMessagesBatchSocketEnvelope | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const arr = o.messages;
  if (!Array.isArray(arr) || arr.length === 0) return null;
  const messages = arr.filter((x): x is MessengerMessage => Boolean(x && typeof x === 'object'));
  if (messages.length === 0) return null;
  const threadRaw = o.thread;
  const thread =
    threadRaw && typeof threadRaw === 'object'
      ? (threadRaw as MessengerSocketThreadMeta)
      : null;
  return { messages, thread };
}
